import { Nav } from "./Nav"

export const About = () => {
    return (
        <div>
            <Nav />
            <div>
                <h2>About page</h2>
                <p>Property analytics dashboard</p>
                <p>Helps you to think like a property investor</p>
                <p>and make decisions</p>
                <p>to find your next investment</p>
                <p>and other things</p>
            </div>
            <div>
                <h2>Where to find me</h2>
                <p>You can read my blog at <a target="_blank" rel="noopener noreferrer" href="clem-sk.dev"></a></p>
            </div>
        </div>
    )
}